import { applyMiddleware, createStore, Store } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import { appReducer } from './reducers/AppReducer';
import { AppState } from './state/AppState';

/**
 * Initializes the Redux store for the app. This should be called once when the app loads,
 * and provided to the rest of the app via setAppStore().
 */
export function initAppStoreAndSagaMiddleware() {
  const sagaMiddleware = createSagaMiddleware();

  // Redux Dev Tools support docs: https://github.com/zalmoxisus/redux-devtools-extension#usage
  const composeEnhancers = composeWithDevTools({
    maxAge: 200,
  });

  const store: Store<AppState> = createStore(appReducer, composeEnhancers(
    applyMiddleware(sagaMiddleware)
  ));

  return { store, sagaMiddleware };
}

/**
 * Initializes an app store. In the app, there should be only a single store, so this function should
 * be called only in the unit tests to make transient stores for testing.
 * TODO: This could be moved into the test directory
 */
export function createAppStoreForUnitTests() {
  const {store} = initAppStoreAndSagaMiddleware();
  return store;
}
